<template>

<control class="switch">

    <div class="switch-toggle" v-is:active="value" v-on:click="onToggleClick" v-tooltip="'Click to change'">

        <div class="switch-tab">

            <icon :n="icon" v-if="icon" />

        </div>

    </div>

</control>

</template>

<script>

export default {

    props: ['value', 'icon'],

    methods: {

        onToggleClick: function() {

            this.$emit('input', !this.value)
            
            this.$emit('change')
            
        }

    }

}

</script>

<style scoped>

.switch-toggle {
    width: 64px;
    height: 32px;
    border-radius: 15px;
    background-color: #EFEFF4;
    cursor: pointer;
    user-select: none;
}

.switch-toggle:not(.is-active):hover {
    background-color: #999;
}

.switch-toggle.is-active {
    background-color: #1AD598;
}

.switch-toggle.is-active:hover {
    background-color: #12be85;
}

.switch-tab {
    width: 26px;
    height: 26px;
    position: absolute;
    top: 3px;
    left: 3px;
    border-radius: 50%;
    line-height: 26px;
    text-align: center;
    font-size: 14px;
    color: #050505;
    background-color: #fff;
    pointer-events: none;
    transition: all 100ms linear;
}

.switch-toggle.is-active .switch-tab {
    left: calc(100% - 29px);
}

</style>
